// React does not sanitize href, so a `javascript:` URL reaching one executes. Component
// props are not always author-written: a docs link can arrive from an API response.
const ALLOWED_SCHEMES = new Set(['http:', 'https:', 'mailto:', 'tel:']);

export const isSafeHref = (href: unknown): href is string => {
    if (typeof href !== 'string') {
        return false;
    }
    // Strip control characters first: `java\u0009script:` is a scheme the naive test misses.
    const scheme = /^([a-z][a-z0-9+.-]*):/i.exec(href.replace(/[\u0000-\u0020]/g, ''));
    // No scheme means relative or fragment, which has nothing to vet.
    return !scheme || ALLOWED_SCHEMES.has(`${scheme[1].toLowerCase()}:`);
};

/** Returns the href only when it is safe to navigate to, so callers can fall back. */
export const safeHref = (href: string | undefined): string | undefined =>
    isSafeHref(href) ? href : undefined;
